'use strict';
// node_modules

// // modules
// const jQueryHelper = require('./helpers/jquery-helper');
// const shared = require('../app/extensions/shared').$;
global.roundToDecimal = require('../../modules/helpers/numbers-helper').roundToDecimal;
global.is = require('../../modules/helpers/is');
//
// const design = {
//     material: require('./design/material'),
// };
//
// const modules = {
//     design: design,
// };

global.LazyLoad = require('./helpers/lazy-load').default;
const ProductEnhancer = require('./helpers/product-enhancer').default;
const AnalyticsHelper = require('./helpers/analytics-helper').default;

const bulmaExtension = require('./bulma-extension');

// properties
const VERSION = '1.0.0';
const NAME = 'fe-scripts';

// methods

let initLanguageSwitch = function () {
    console.log(NAME, 'initLanguageSwitch');
    document.querySelectorAll(`select[data-switch="language"]`).forEach(element => {
        element.addEventListener('change', function() {
            console.log(NAME, 'language_switch', this.value, defaultLocale);
            let type = this.getAttribute('data-type');
            if (type === 'page') {
                window.location = this.value + window.location.search;
                return;
            }
            window.location = (this.value === defaultLocale ? '/' : '/' + this.value + '/') + window.location.search;
        });
    });
};

let initCurrencySwitch = function () {
    console.log(NAME, 'initCurrencySwitch');
    document.querySelectorAll(`select[data-switch="currency"]`).forEach(element => {
        element.addEventListener('change', function() {
            console.log(NAME, 'currency_switch', this.value);
            window.location.search = `currencyCode=${this.value}`
        });
    });
};

let initCountrySwitch = function () {
    console.log(NAME, 'initCountrySwitch');
    document.querySelectorAll(`select[data-switch="country"]`).forEach(element => {
        element.addEventListener('change', function() {
            console.log(NAME, 'country_switch', this.value);
            window.location.search = `countryCode=${this.value}`
        });
    });
};

let init = () => {
    console.log(NAME, 'init');

    bulmaExtension.initNavBars();

    // window.$ = global.$ = window.$ || {};
    // jQueryHelper.extend(window.$, shared);

    // // console.log(NAME, $.is.nue('hello'), $.text.format('this is my text', $.text.FORMAT_TYPE.DIR));

    initLanguageSwitch();
    initCurrencySwitch();
    initCountrySwitch();

    bulmaExtension.initModals();
    bulmaExtension.initDropdowns();
    bulmaExtension.initExpandableContent();
    bulmaExtension.initTabs();

    // init modules
    console.log(NAME, 'initModules', enabledModules);
    enabledModules = Array.from(new Set(enabledModules));
    enabledModules.forEach(moduleName => {
        let module;
        try {
            module = require('./modules/' + moduleName);
        } catch (e) {
            // console.error(e);
        }
        if (module) {
            module.init();
        }
    });

    // load css
    console.log(NAME, 'loadCSS', enabledStyles);
    function loadStylesCallback() {
        enabledStyles.forEach(style => {
            loadCSS(style);
        });
    }
    let raf = requestAnimationFrame || mozRequestAnimationFrame ||
        webkitRequestAnimationFrame || msRequestAnimationFrame;
    if (raf) raf(loadStylesCallback);
    else window.addEventListener('load', loadStylesCallback);

    // load fonts
    console.log(NAME, 'loadFonts', enabledFonts);
    enabledFonts.forEach(font => {
        loadFont(font);
    });

    // console.log('LazyLoad', LazyLoad);
    LazyLoad.init();
    ProductEnhancer.init();
    AnalyticsHelper.init();
};



const loadFont = (url) => {
    // the 'fetch' equivalent has caching issues
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onreadystatechange = () =>
    {
        if (xhr.readyState === 4 && xhr.status === 200) {
            let css = xhr.responseText;
            css = css.replace(/}/g, 'font-display: swap; }');

            const head = document.getElementsByTagName('head')[0];
            const style = document.createElement('style');
            style.appendChild(document.createTextNode(css));
            head.appendChild(style);
        }
    }
    ;
    xhr.send();
};

const loadCSS = (url) => {
    const head = document.getElementsByTagName('head')[0];

    const link = document.createElement('link');
    link.rel  = 'stylesheet';
    link.type = 'text/css';
    link.href = url;
    //link.media = 'all';
    head.appendChild(link);

    // link(rel="stylesheet", href="/stylesheets/" + (frontEnd.stylesheet || "all") + ".css")
};

window.randomId = () => {
    return Math.random().toString(36).substring(2);
};

window.addEventListener("DOMContentLoaded", init);
// window.addEventListener("load", init);

module.exports = {
    VERSION: VERSION,
    NAME: NAME,
};